import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import { AccountContext } from "../accountContext";
import { Button } from "@mantine/core";
import { Accordion } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import ArticleContainer from "./ArticleContainer";

const useStyles = makeStyles((theme) => ({
  pageInfo: {
    fontSize: "0.875rem",
    color: theme.app.secondaryColor,
    marginBottom: "16px",
    marginTop: ".5rem",
  },

  back: {
    marginTop: "16px",
    borderTop: `1px solid ${theme.app.borderColor}`,
    padding: "8px 0",
    gridTemplateColumns: "1fr auto",
    alignItems: "center",
  },
  titleContainer: {
    padding: "16px 20px 0",
    display: "flex",
    flexDirection: "row",
    gap: "50px",
    "@media(max-width: 800px)": {
      gap: "25px",
    },
    "@media(max-width: 667px)": {
      gap: "10px",
      padding: "0 10px",
    },
    "@media(max-width: 400px)": {
      padding: "0px",
    },
  },
  titles: {
    width: "150px",
    fontWeight: "500",
  },
}));

const SaleHistory = () => {
  const classes = useStyles();
  const accountContext = useContext(AccountContext);
  const sales = accountContext.state.accountData.member.saleHistory;

  // Sorting copy of sales array by saleDate descending
  const sortedSales = [...sales].sort(
    (a, b) => new Date(b.saleDate) - new Date(a.saleDate)
  );
  const language = useSelector((state) => state.language);
  const isMobile = useMediaQuery("(max-width: 500px)");

  const [value, setValue] = useState(null);

  return (
    <div className={classes.saleHistory}>
      <Typography variant="h1">{language.Pages["sale history"]}</Typography>
      <Typography className={classes.pageInfo}>
        {language.PageInfo["sale history"]}
      </Typography>
      <div className={classes.titleContainer}>
        <p className={classes.titles}>{language.Sale_History["date"]}</p>
        <p className={classes.titles}>
          {language.Sale_History[isMobile ? "sale id short" : "sale id"]}
        </p>
        <p className={classes.titles}>
          {language.Sale_History[isMobile ? "pos name short" : "pos name"]}
        </p>
        <p className={classes.titles}>{language.Sale_History["total"]}</p>
        <p> </p>
      </div>
      <Accordion value={value} onChange={setValue}>
        {sortedSales.map((sale) => (
          <ArticleContainer value={value} sale={sale} />
        ))}
      </Accordion>

      <div className={classes.back}>
        <Button
          className={`${classes.button}`}
          onClick={() => window.history.back()}
          color="dark"
          variant="subtle"
        >
          Tillbaka
        </Button>
      </div>
    </div>
  );
};

export default SaleHistory;
